import React from 'react'

const DiscoverCicleIcon = ({ className, size = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 120 128`}
      fill="#fff">
      <path d="M79.9997 114.665C116.819 114.665 146.666 84.8177 146.666 47.9987C146.666 11.1797 116.819 -18.668 79.9997 -18.668C43.1807 -18.668 13.333 11.1797 13.333 47.9987C13.333 84.8177 43.1807 114.665 79.9997 114.665Z" stroke="black" strokeOpacity="0.08" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M60 48.0013L73.3333 61.3346L100 34.668" stroke="black" strokeOpacity="0.08" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default DiscoverCicleIcon
